import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../lib/api';
import ProductCard from '../components/ProductCard';
import { ChevronRight } from 'lucide-react';

export default function ProductListingPage() {
  const [searchParams] = useSearchParams();
  const category = searchParams.get('category');
  const subcategory = searchParams.get('subcategory');
  const search = searchParams.get('search');
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = new URLSearchParams();
    if (category) params.set('category', category);
    if (subcategory) params.set('subcategory', subcategory);
    if (search) params.set('search', search);
    api.get(`/products?${params.toString()}`).then(r => { setProducts(r.data || []); setLoading(false); }).catch(() => setLoading(false));
  }, [category, subcategory, search]);

  const title = search ? `Results for "${search}"` : subcategory ? subcategory.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : category ? category.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : 'All Products';

  return (
    <div data-testid="product-listing-page" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <nav className="flex items-center gap-2 text-sm text-muted-foreground mb-8">
        <Link to="/" className="hover:text-foreground transition-colors">Home</Link>
        <ChevronRight className="h-3.5 w-3.5" />
        {category && (
          <>
            <Link to={`/category/${category}`} className="hover:text-foreground transition-colors capitalize">{category.replace(/-/g, ' ')}</Link>
            <ChevronRight className="h-3.5 w-3.5" />
          </>
        )}
        <span className="text-foreground font-medium capitalize">{title}</span>
      </nav>

      <div className="mb-8">
        <h1 data-testid="listing-title" className="text-3xl sm:text-4xl font-serif font-medium tracking-tight mb-2 capitalize">{title}</h1>
        <p className="text-muted-foreground text-sm">{products.length} {products.length === 1 ? 'product' : 'products'} available</p>
      </div>

      {loading ? (
        <div className="flex justify-center py-20"><div className="animate-spin h-8 w-8 border-2 border-primary border-t-transparent rounded-full" /></div>
      ) : products.length === 0 ? (
        <div data-testid="no-products-message" className="text-center py-20">
          <p className="text-muted-foreground text-lg">No products found</p>
          <Link to="/products" className="text-primary hover:underline text-sm mt-2 inline-block">Browse all products</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5">
          {products.map((p) => <ProductCard key={p.product_id} product={p} />)}
        </div>
      )}
    </div>
  );
}
